import {
    BulkResultBean,
    ItemResponseSiteBeanObject,
    ListResponseSiteBean,
    SiteBean,
    SiteControllerApi
} from 'common/api/api.ts'
import {BaseApi, configuration} from 'common/api/BaseApi.ts'
import {processError} from 'common/api/fetch.ts'
import axios from 'axios'
import { downloadCSVData } from 'common/util/Util.tsx'

class SiteApi extends BaseApi {
    api: SiteControllerApi

    constructor() {
        super()
        this.api = new SiteControllerApi(configuration, configuration.basePath, this.fetch)
    }

    // async list(size: number = 20, page: number = 1): Promise<ListResponseSiteBean> {
    //   try {
    //     let list = await this.api.siteList({ query: { size: size, page: page } })
    //     return Promise.resolve(list)
    //   } catch (err) {
    //     return processError(err)
    //   }
    // }

    list = (
        sortFieldName?: string,
        sortOrder?: string,
        searchByName?: string,
        active?: boolean,
        publisherId?: number,
        options?: any
    ) => this.api.siteList(
        sortFieldName,
        sortOrder,
        searchByName,
        active,
        publisherId,
        options
    )

    async listByPublisher(size: number = 20, page: number = 1, pubId: number): Promise<ListResponseSiteBean> {
        try {
            let list = await this.api.siteListByPublisherId(pubId, { query: { size: size, page: page } })
            return Promise.resolve(list)
        } catch (err) {
            return processError(err)
        }
    }

    async all(): Promise<ListResponseSiteBean> {
        try {
            let all = await this.api.siteList()
            return Promise.resolve(all)
        } catch (err) {
            return processError(err)
        }
    }

    view(id: number): Promise<ItemResponseSiteBeanObject> {
        return this.api.site(id)
    }

    create(bean: SiteBean): Promise<ItemResponseSiteBeanObject> {
        return this.api.createSite(bean)
    }

    createSiteBulk(csv: any): Promise<BulkResultBean> {
        const data = new FormData()
        data.append('csv', csv)
        return axios
            .post(configuration.basePath + '/api/site/bulk', data, { withCredentials: true })
            .then((res) => Promise.resolve(res.data))
            .catch((err) => processError(err))
    }

    edit(id: number, bean: SiteBean): Promise<ItemResponseSiteBeanObject> {
        return this.api.editSite(bean, id)
    }

    delete(id: number): Promise<Response> {
        return this.api.deleteSite(id)
    }

    // async changeStatus(id: number) {
    //   try {
    //     const ssp = await this.api.changeSspStatus(id);
    //     return Promise.resolve(ssp);
    //   } catch (err) {
    //     return processError(err);
    //   }
    // }

    getCsv(csvName: string): Promise<any> {
        return this.api
            .getSiteCsv()
            .then((response: Response) => {
                return Promise.resolve(
                    response
                        .blob()
                        .then((blob) => {
                            return Promise.resolve(downloadCSVData(csvName, blob))
                        })
                        .catch((err) => {
                            return processError(err)
                        })
                )
            })
            .catch((err) => {
                return processError(err)
            })
    }

    setActive = (id: number, active: boolean) => this.api.setActive(id, active)
}

const siteApi = new SiteApi()
export default siteApi
